var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1280,
    height: 24,
    viewBox: "0 0 1280 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1287 0H-7V24H1287V0Z",
    fill: "url(#paint0_linear_27_2565)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_27_2565",
    x1: -7,
    y1: 12,
    x2: 421.591,
    y2: -426.165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.245,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#FF0048"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.735,
    stopColor: "#DD00FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF0048"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTop);
export default __webpack_public_path__ + "static/media/header-top.52b3b49b89cdd498c826e03a2cc28495.svg";
export { ForwardRef as ReactComponent };